import { ModalControlsSaveableFactory } from '®shared/modals';

import {
  RequestReviewActionTypes,
  RequestReviewActions,
} from './request-review.actions';
import {
  REQUEST_REVIEW_INITIAL_STATE,
  RequestReviewState,
} from './request-review.state';

export function requestReviewReducer(
  state: RequestReviewState = REQUEST_REVIEW_INITIAL_STATE,
  action: RequestReviewActions,
): RequestReviewState {
  switch (action.type) {
    case RequestReviewActionTypes.REQUEST_REVIEW_SHOW_MODAL: {
      const { listId } = action.payload;
      return {
        listId,
        modalControls: ModalControlsSaveableFactory.show(),
      };
    }

    case RequestReviewActionTypes.REQUEST_REVIEW_SEND_REQUEST: {
      const { listId } = action.payload;
      return {
        listId,
        modalControls: ModalControlsSaveableFactory.saving(),
      };
    }

    case RequestReviewActionTypes.REQUEST_REVIEW_SEND_REQUEST_FAILED: {
      const { listId, error } = action.payload;
      return {
        listId,
        modalControls: ModalControlsSaveableFactory.errorSaving(error),
      };
    }

    case RequestReviewActionTypes.REQUEST_REVIEW_SEND_REQUEST_SUCCEEDED:
    case RequestReviewActionTypes.REQUEST_REVIEW_HIDE_MODAL: {
      return {
        listId: null,
        modalControls: ModalControlsSaveableFactory.hide(),
      };
    }

    default: {
      return state;
    }
  }
}
